import React from "react";

export const LockFillIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M2.50011 18.4999V17.4999H21.5001V18.4999H2.50011ZM3.03511 12.5269L2.27311 12.0849L3.23811 10.3919H1.30811V9.50785H3.23811L2.27311 7.86585L3.03511 7.42285L4.00011 9.06585L4.96611 7.42285L5.72711 7.86585L4.76211 9.50785H6.69211V10.3919H4.76211L5.72711 12.0849L4.96511 12.5269L4.00011 10.8349L3.03511 12.5269ZM11.0351 12.5269L10.2731 12.0849L11.2391 10.3919H9.3081V9.50785H11.2381L10.2731 7.86585L11.0351 7.42285L12.0001 9.06585L12.9661 7.42285L13.7271 7.86585L12.7621 9.50785H14.6921V10.3919H12.7621L13.7271 12.0849L12.9651 12.5269L12.0001 10.8349L11.0351 12.5269ZM19.0351 12.5269L18.2731 12.0849L19.2391 10.3919H17.3081V9.50785H19.2381L18.2731 7.86585L19.0351 7.42285L20.0001 9.06585L20.9661 7.42285L21.7271 7.86585L20.7621 9.50785H22.6921V10.3919H20.7621L21.7271 12.0849L20.9651 12.5269L20.0001 10.8349L19.0351 12.5269Z"
        fill="black"
      />
    </svg>
  );
};
